import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../App.css";

const horses = [
  { id: 1, name: "Thunder", image: "/img/thunder.jpg" },
  { id: 2, name: "Blaze", image: "/img/blaze.jpg" },
  { id: 3, name: "Spirit", image: "/img/spirit.jpg" },
  { id: 4, name: "Shadow", image: "/img/shadow.jpg" },
];

const LandingPage = () => {
  const navigate = useNavigate();

  const handleBookNow = () => {
    navigate("/booking");
  };

  return (
    <div className="landing-page">
      <motion.h1
        initial={{ opacity: 0, x: -15 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 1,
          type: "spring",
          stiffness: 100,
          delay: 0.1,
        }}
        className="gradient__text"
      >
        Welcome to the Horse Ride Booking System
      </motion.h1>
      <div className="horse-list">
        {horses.map((horse) => (
          <motion.div
            key={horse.id}
            className="horse-card"
            initial={{ opacity: 0, x: -150 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{
              duration: 1,
              type: "spring",
              stiffness: 100,
              delay: 0.2,
            }}
          >
            <motion.div
              initial={{ scale: 0, x: 40 }}
              whileInView={{ scale: 0.8, x: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                type: "spring",
                stiffness: 100,
                delay: 0.6,
              }}
            >
              <img src={horse.image} alt={horse.name} />
            </motion.div>
            <motion.h2
              initial={{ scale: 0, x: -150 }}
              whileInView={{ scale: 0.8, x: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                type: "spring",
                stiffness: 100,
                delay: 1,
              }}
            >
              {horse.name}
            </motion.h2>
          </motion.div>
        ))}
      </div>
      <motion.button    
        initial={{ opacity: 0, x: -150 }}
        whileInView={{ opacity: 1, x: 0 }} 
        viewport={{ once: true }}
        transition={{
          duration: 1,
          type: "spring",
          stiffness: 100,
          delay: 0.3,
        }}
        onClick={handleBookNow}
      >
        <motion.span    
        initial={{ opacity: 0, x: 150 }}
        whileInView={{ opacity: 1, x: 0 }} 
        viewport={{ once: true }}
        transition={{
          duration: 1,
          type: "spring",
          stiffness: 100,
          delay: 1,
        }}
      >
        Book Now
      </motion.span>        
      </motion.button>
    </div>
  );
};

export default LandingPage;